// commonNames.js
export const commonNames = [
  'Alex',
  'Emma',
  'David',
  'Michael',
  'Isabella',
  'Daniel',
  'Maria',
  'Matthew',
  'Juan',
  'Christopher',
  'Luis',
  'Sarah',
  'Carlos',
  'Ashley',
  'Jose',
  'Jessica',
  'Ana',
];

export const nameWeights = {
  Alex: 3,
  Emma: 3,
  Sofia: 3,
  David: 2,
  Michael: 2,
  Maria: 2,
  Isabella: 2,
  Juan: 2,
  Luis: 2,
  Carlos: 2,
  // all others default to 1
};
